import * as d3 from "d3";

export const kdeKernel: Kernel = "epanechnikov";
export const kdeBandwidth = 1;
export const kdePoints = d3.range(0, 8, 1);

// Kernels
// ----------------------------------------------------------------------------

export type Kernel = keyof typeof kernels;
const kernels = {
  epanechnikov(u: number): number {
    if (Math.abs(u) <= 1) {
      return 0.75 * (1 - u * u);
    } else {
      return 0;
    }
  },
  gaussian(u: number): number {
    return (1 / Math.sqrt(2 * Math.PI)) * Math.exp(-0.5 * u * u);
  },
  triangular(u: number): number {
    if (Math.abs(u) <= 1) {
      return 1 - Math.abs(u);
    } else {
      return 0;
    }
  },
};

// An optimized version of 'd3.mean'.
const mean = <T>(xs: T[], f: (x: T) => number): undefined | number => {
  if (xs.length === 0) {
    return undefined;
  } else {
    let a = 0;
    for (let j = 0, len = xs.length; j < len; j++) {
      const x = xs[j];
      a = a + f(x);
    }
    return a / xs.length;
  }
};

const kernelDensityEstimator = (kernel: (x: number) => number, xs: number[]) => (sample: number[]) =>
  xs.map((x) => [x, mean(sample, (v) => kernel(x - v))]);

const scaleKernel = (kernel: (x: number) => number, h: number) => (u: number) => kernel(u / h) / h;

export const kde = kernelDensityEstimator(scaleKernel(kernels[kdeKernel], kdeBandwidth), kdePoints);
